var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDebateSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#f5f4f4",
    height: "239px",
    width: "239px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-48.79 -48.79 300.88 300.88",
    xmlSpace: "preserve",
    transform: "matrix(-1, 0, 0, 1, 0, 0)",
    stroke: "#f5f4f4",
    strokeWidth: 0.0020330500000000002,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-48.79, -48.79), scale(18.805)",
    fill: "#3980d5",
    d: "M9.166.33a2.25 2.25 0 00-2.332 0l-5.25 3.182A2.25 2.25 0 00.5 5.436v5.128a2.25 2.25 0 001.084 1.924l5.25 3.182a2.25 2.25 0 002.332 0l5.25-3.182a2.25 2.25 0 001.084-1.924V5.436a2.25 2.25 0 00-1.084-1.924L9.166.33z",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 1.62644
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42.528,83.982c17.265,0,31.31-14.045,31.31-31.31c0-17.266-14.046-31.314-31.31-31.314 c-17.264,0-31.31,14.047-31.31,31.314C11.219,69.937,25.264,83.982,42.528,83.982z M42.528,36.359 c8.994,0,16.31,7.318,16.31,16.314c0,8.993-7.317,16.31-16.31,16.31c-8.993,0-16.31-7.316-16.31-16.31 C26.219,43.678,33.535,36.359,42.528,36.359z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.704,92.087H30.547C13.703,92.087,0,105.792,0,122.638v51.808c0,4.142,3.358,7.5,7.5,7.5c4.142,0,7.5-3.358,7.5-7.5 v-51.808c0-8.575,6.974-15.551,15.547-15.551h24.157c8.572,0,15.546,6.976,15.546,15.551v51.808c0,4.142,3.358,7.5,7.5,7.5 c4.142,0,7.5-3.358,7.5-7.5v-51.808C85.25,105.792,71.547,92.087,54.704,92.087z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.584,83.982c17.265,0,31.311-14.045,31.311-31.31c0-17.266-14.046-31.314-31.311-31.314 c-17.265,0-31.311,14.047-31.311,31.314C129.273,69.937,143.319,83.982,160.584,83.982z M160.584,36.359 c8.994,0,16.311,7.318,16.311,16.314c0,8.993-7.316,16.31-16.311,16.31c-8.994,0-16.311-7.316-16.311-16.31 C144.273,43.678,151.59,36.359,160.584,36.359z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.759,92.087h-24.157c-16.843,0-30.546,13.705-30.546,30.551v51.808c0,4.142,3.357,7.5,7.5,7.5s7.5-3.358,7.5-7.5 v-51.808c0-8.575,6.974-15.551,15.546-15.551h24.157c8.572,0,15.546,6.976,15.546,15.551v51.808c0,4.142,3.357,7.5,7.5,7.5 c4.143,0,7.5-3.358,7.5-7.5v-51.808C203.305,105.792,189.602,92.087,172.759,92.087z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.733,66.968c-3.706-1.854-8.211-0.351-10.063,3.354l-7.27,14.538l-6.768-13.535c-1.852-3.705-6.357-5.208-10.062-3.354 c-3.705,1.852-5.207,6.357-3.354,10.062l13.476,26.951c1.27,2.541,3.867,4.146,6.708,4.146c2.841,0,5.437-1.605,6.708-4.146 l13.978-27.954C123.939,73.325,122.438,68.82,118.733,66.968z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebateSvgrepoCom);
export default __webpack_public_path__ + "static/media/debate-svgrepo-com.29f17473b3513fb90126194a05a211d7.svg";
export { ForwardRef as ReactComponent };